import React from 'react';
import './App.css';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Work from './components/Work';
import Footer from './components/Footer';
import Rating from './components/Rating';

function App() {
  const backgroundColor = '#222831'; // Beige cream color

  return (
    <div style={{ backgroundColor }}>
      
      <div id="about">
        <About backgroundColor={backgroundColor} />
      </div>
      <br />
        <Skills backgroundColor={backgroundColor} />
      <br />
      <div id="projects">
        <Projects backgroundColor={backgroundColor} />
      </div>
      <br />
      <div id="work">
        <Work backgroundColor={backgroundColor} />
      </div>
      <br />
      <div id="rating">
        <Rating backgroundColor={backgroundColor} />
      </div>
      <br />
      <Footer backgroundColor={backgroundColor} />
    </div>
  );
}

export default App;
